import React from 'react';
// import ProjectScreens from '../ProjectScreens';
import TechnologieCard from '../TechnologieCard';
import './styles.css';

interface ProjectCardProps {
    image: string;
    name: string;
    stack: string;
    description: string;
    codeLink: string;
    siteLink: string;
    technologies: Array<{
        id: string,
        name: string
    }>
}

const ProjectCard: React.FC<ProjectCardProps> = ({image, codeLink, siteLink, description, name, stack, technologies}) => {
    return (
        <div className="project-card">
            <div className="project-card-inner">
                <div className="project-card-front">
                    <img src={image} alt={name}/>
                    <p>detalhes</p>
                    <p>Clique para ver</p>
                </div>
                <div className="project-card-back">
                    <div className="project-card-informations">
                        <h1>{name}</h1>
                        <h2>{stack}</h2>
                        <div className="project-technologies">
                            {technologies.map(technologie => {
                                return<TechnologieCard key={technologie.id} name={technologie.name}/>
                            })}
                        </div>
                        <p>{description}</p>
                        <div className="project-card-buttons">
                            <button className="github-button">
                                <a href={codeLink} target="blank">Ver Código</a>
                            </button>
                            <button className="github-button">
                                <a href={siteLink} target="blank">Ver Site</a>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectCard;